import React from 'react';
import PropTypes from 'prop-types';

import styles from './Tooltip.module.scss';

const TooltipPosition = {
    Above: 'tooltip-above',
    Below: 'tooltip-below',
    Right: 'tooltip-right',
};

const Tooltip = ({ content, position }) => (
    <div className={ `${styles['tooltip-component']} ${ styles[position || TooltipPosition.Below] }` }>
        { content }
    </div>
);
Tooltip.propTypes = {
    position: PropTypes.oneOf([
        TooltipPosition.Below,
        TooltipPosition.Above,
        TooltipPosition.Right,
    ]),
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default Tooltip;
export { TooltipPosition };